import { ENDPOINT_CARTS, ENDPOINT_ROOT } from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

const postCart = ({ name, worksite, source, items }) => {
  const params = {
    name,
    worksite_code: worksite?.code,
    source,
    items: items ?? [],
  };

  return axiosAuth
    .post(`${ENDPOINT_ROOT}/${ENDPOINT_CARTS}`, params)
    .then((res) => res.data);
};

export default postCart;
